import React, { forwardRef } from 'react';
import { PrintConversation } from './styled';
import IconG4 from 'assets/img/theme/iconG4.png';
import UserBalloon from '../../../ChatBallons/User';
import ClientBalloon from '../../../ChatBallons/Client';
import SpyBallon from '../../../ChatBallons/Spy';
import { TransferMessage } from '../TransferMessage';
import { EndChatMessage } from '../EndChatMessage';

const PrintMultipleConversations = forwardRef(({ conversations }, ref) => (
  <div ref={ref}>
    {conversations.map((conversation, idx) => (
      <PrintConversation key={conversation._id || conversation.id || idx}>
        <h3>
          Cliente: {conversation.cliente?.nome || 'Não informado'} | Canal:{' '}
          {conversation.canal || ''}
        </h3>
        <img src={IconG4} alt="logo" id="logoG4PDF" />

        {conversation.mensagens &&
          conversation.mensagens.map((el, index) => {
            if (!el) return null;
            if (
              el.cliente_ou_atendente === 'atendente' ||
              el.cliente_ou_atendente === 'admin'
            ) {
              return el.cliente_ou_atendente === 'atendente' ? (
                <React.Fragment key={index}>
                  {el?.actions?.action === 'answer' && (
                    <TransferMessage action={el?.actions} />
                  )}
                  {el?.actions?.action === 'finish_chat_conversation' && (
                    <EndChatMessage
                      message={el?.actions?.message || 'Conversa encerrada'}
                    />
                  )}
                  {!(el.response_type === 'text' && !el.texto) && (
                    <UserBalloon
                      todasMensagens={conversation.mensagens}
                      name={el.escrita_por}
                      type={el.response_type}
                      message={el.texto}
                      isAutomatic={el?.isAutomatic ?? false}
                      title={el.title}
                      time={el.hora_da_mensagem}
                      options={el.options}
                      source={el.source}
                    />
                  )}
                  {(el?.actions?.action === 'transfer_to_queue' ||
                    el?.actions?.action === 'transfer_to_agent') && (
                    <TransferMessage action={el?.actions} />
                  )}
                </React.Fragment>
              ) : (
                <SpyBallon
                  key={index}
                  name={el.escrita_por}
                  type={el.response_type}
                  message={el.texto}
                  title={el.title}
                  time={el.hora_da_mensagem}
                  options={el.options}
                  source={el.source}
                />
              );
            } else {
              return (
                <ClientBalloon
                  key={index}
                  todasMensagens={conversation.mensagens}
                  name={el.escrita_por}
                  type={el.response_type}
                  message={el.texto}
                  title={el.title}
                  time={el.hora_da_mensagem}
                  options={el.options}
                  source={el.source}
                  contact={el.contact}
                />
              );
            }
          })}
        <hr style={{ margin: '20px 0' }} />
      </PrintConversation>
    ))}
  </div>
));
PrintMultipleConversations.displayName = 'PrintMultipleConversations';

export default PrintMultipleConversations;
